module.exports = __webpack_public_path__ + "om.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/om.svg
// module id = 1001
// module chunks = 0